import { buildUrl } from "helpers";
import { instance } from "libs/api";

import { ApiRoutesInventory } from "./../../constants";

export const requestDeleteInventoryBoxQr = async (
  inventoryBoxQrId: string
): Promise<void> => {
  return await instance.delete(
    buildUrl(ApiRoutesInventory.InventoryBox, inventoryBoxQrId)
  );
};
